// extracted by mini-css-extract-plugin
export var addButton = "_5f-d";
export var bullets = "_5f-e";
export var compact = "_5f-2";
export var container = "_5f-j";
export var extendedWarrantyModal = "_5f-f";
export var learn = "_5f-l";
export var learnMore = "_5f-g";
export var offeringOption = "_5f-3";
export var offeringPrice = "_5f-8";
export var offeringSubtitle = "_5f-7";
export var offeringTitle = "_5f-6";
export var offeringsContainer = "_5f-0";
export var pdpTilesBackground = "_5f-n";
export var plan = "_5f-m";
export var regular = "_5f-1";
export var remove = "_5f-k";
export var seeDetailsIcon = "_5f-i";
export var seeDetailsLink = "_5f-h";
export var selectedOption = "_5f-4";
export var shieldIcon = "_5f-b";
export var shieldIconCompact = "_5f-c";
export var subtitle = "_5f-a";
export var title = "_5f-9";
export var unselectedOption = "_5f-5";